import { ThunkType } from "../../../../core/store/reducers";
import getSecurityRevenueEstimateApi from "../api/getSecurityRevenueEstimate";
import { setDisplayedRevenueEstimate } from "../statisticsDataSlice";
import { RevenueEstemateItem } from "../types";

// Load funkcija (reset + fetch)
export const loadSecurityRevenueEstimate = (
	symbol: string
): ThunkType => async (dispatch, getStore) => {
	// reset prethodnih podataka
	dispatch(setDisplayedRevenueEstimate(undefined));

	const statistics = await dispatch(
		getSecurity_RevenueEstimate(symbol)
	);

	dispatch(setDisplayedRevenueEstimate(statistics));
};

export const getSecurity_RevenueEstimate = (
	symbol: string
): ThunkType<Promise<RevenueEstemateItem | undefined>> =>
	async (dispatch, getStore, _extra) => {

		const store = getStore();

		if (store.data.auth.current.status !== "successful") {
			return undefined;
		}

		const { userId } = store.data.auth.current.user;

		const response = await dispatch(
			getSecurityRevenueEstimateApi(userId, symbol, "revenue_estimate")
		);

		console.log(response)
		if (!response || !response.meta) {
			return undefined;
		}
		const latest = response?.revenue_estimate?.[0];

		return {
			symbol: response.meta.symbol,
			date: latest.date,
			period: latest.period,
			number_of_analysts: latest.number_of_analysts,
			avg_estimate: latest.avg_estimate,
			low_estimate: latest.low_estimate,
			high_estimate: latest.high_estimate,
			year_ago_eps: latest.year_ago_eps,
			sales_growth: latest.sales_growth,
			year_ago_sales: latest.year_ago_sales,
		};
	};


